if (!customElements.get('mo-slider')) {
  customElements.define('mo-slider', class extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.mo-slider-track');
      this.slides = this.querySelectorAll('.mo-slide');
      this.dots = this.querySelectorAll('.mo-dot');
      this.prevBtn = this.querySelector('.mo-arrow.prev');
      this.nextBtn = this.querySelector('.mo-arrow.next');
      this.currentIndex = 0;
      this.autoPlayInterval = null;

      if (this.slides.length <= 1) return;

      // Event Listeners for Arrows
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollSlide(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollSlide(1));

      // Event Listeners for Dots
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Update dots on manual swipe/scroll
      this.track.addEventListener('scroll', () => {
        let index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (index !== this.currentIndex && index >= 0 && index < this.slides.length) {
          this.updateDots(index);
        }
      });

      // Autorotate
      if (this.dataset.autorotate === 'true') {
        this.startAutoPlay();
        this.addEventListener('mouseenter', () => this.stopAutoPlay());
        this.addEventListener('mouseleave', () => this.startAutoPlay());
      }
    }

    scrollSlide(direction) {
      let newIndex = this.currentIndex + direction;
      if (newIndex >= this.slides.length) newIndex = 0;
      if (newIndex < 0) newIndex = this.slides.length - 1;
      this.goToSlide(newIndex);
    }

    goToSlide(index) {
      this.track.scrollTo({
        left: index * this.track.clientWidth,
        behavior: 'smooth'
      });
      this.updateDots(index);
    }

    updateDots(index) {
      this.currentIndex = index;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }

    startAutoPlay() {
      const speed = parseInt(this.dataset.speed) || 5000;
      this.stopAutoPlay();
      this.autoPlayInterval = setInterval(() => this.scrollSlide(1), speed);
    }

    stopAutoPlay() {
      if (this.autoPlayInterval) clearInterval(this.autoPlayInterval);
    }
  });
}